import React from 'react';
import {ISelectProps, SelectInput} from '~/components/Controls/Select';
import {FormField, hasError, IFieldProps, onChangeField} from '~/components/Form';
import {Intent} from '~/lib/intent';
import {useResource} from '~/lib/loader';
import {fetchBidderProtocols} from '~/modules/Bidders/api';

type ISelectBidderProtocolProps = Omit<ISelectProps<string>, 'items'>;

export const SelectBidderProtocol = ({
    disabled,
    ...props
}: ISelectBidderProtocolProps) => {
    const {resource, isPending} = useResource(() => fetchBidderProtocols(), []);
    return <SelectInput {...props} disabled={disabled || isPending}
        rightIcon={isPending && <i className='fa fa-spinner fa-spin'/>}
        items={resource.map(protocol => ({
            label: protocol,
            value: protocol
        }))}/>;
};

export const SelectBidderProtocolField = (props: IFieldProps<ISelectBidderProtocolProps>) => <FormField {...props}>
    <SelectBidderProtocol {...props.options}
        intent={hasError(props) && Intent.DANGER}
        value={props.field.value} onChange={value => onChangeField(props, value)}
    />
</FormField>;
